// ============================================================================
// HOOK: useContractModals — Estado de modais e diálogos do ContractEngine
// ARQUIVO: src/hooks/useContractModals.js
// RESPONSABILIDADE: Isolar estados de UI (modais, diálogos, preflight).
// ============================================================================

import { useState } from 'react';

export function useContractModals() {
  const [dialogState, setDialogState] = useState({ open: false, title: '', message: '', mode: 'confirm', onConfirm: null, onCancel: null });
  const [preFlightState, setPreFlightState] = useState({ open: false, publishType: 'simple', format: 'html', cadernoId: '', cadernoTitle: '' });
  const [showImportModal, setShowImportModal] = useState(false);
  const [showPartnerImportModal, setShowPartnerImportModal] = useState(false);
  const [showProvisionModal, setShowProvisionModal] = useState(false);
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [hydratingDeepClients, setHydratingDeepClients] = useState(false);

  const openDialog = ({ title, message, mode = 'confirm', onConfirm = null, onCancel = null }) => {
    setDialogState({ open: true, title, message, mode, onConfirm, onCancel });
  };

  const closeDialog = () => {
    setDialogState((prev) => ({ ...prev, open: false }));
  };

  const openPreFlight = (publishType = 'simple', format = 'html') => {
    setPreFlightState((prev) => ({
      ...prev,
      open: true,
      publishType: String(publishType || 'simple').trim().toLowerCase() === 'consent' ? 'consent' : 'simple',
      format: String(format || 'html').trim().toLowerCase() === 'pdf' ? 'pdf' : 'html',
    }));
  };

  const closePreFlight = () => {
    setPreFlightState({ open: false, publishType: 'simple', format: 'html', cadernoId: '', cadernoTitle: '' });
  };

  const setPreFlightCaderno = (cadernoId, cadernoTitle = '') => {
    setPreFlightState((prev) => ({ ...prev, cadernoId: String(cadernoId || '').trim(), cadernoTitle: String(cadernoTitle || '').trim() }));
  };

  return {
    dialogState, setDialogState,
    preFlightState, setPreFlightState,
    showImportModal, setShowImportModal,
    showPartnerImportModal, setShowPartnerImportModal,
    showProvisionModal, setShowProvisionModal,
    showDeliveryModal, setShowDeliveryModal,
    hydratingDeepClients, setHydratingDeepClients,
    openDialog, closeDialog,
    openPreFlight, closePreFlight,
    setPreFlightCaderno,
  };
}
